import { render, staticRenderFns } from "./zh_ods_nyj.vue?vue&type=template&id=2010c1f8&"
import script from "./zh_ods_nyj.vue?vue&type=script&lang=js&"
export * from "./zh_ods_nyj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports